import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TaskService } from '../../../../core/timeline';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TaskFilterService } from '../task-filter-utility.service';

@Component({
  selector: 'kt-task-by-category',
  templateUrl: './task-by-category.component.html',
  styleUrls: ['./task-by-category.component.scss'],
})
export class TaskByCategoryComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  categories = [];
  userObjects;
  userIds = [];
  groupedByTemplate = false;
  groupedByTeam = false;
  groupedByTag = false;
  groupedByPatient = false;
  categoryId;
  categoryName: string; // from routing path
  isFiltered = false;
  filtered = `<span style="font-weight: 500;
    color: #7c7a7a;}">(Filtered)</span>`;
  filteredEntities;
  tempFilteredEntities;
  filteredView;
  constructor(
    private taskService: TaskService,
    private cdr: ChangeDetectorRef,
    public _location: Location,
    private route: ActivatedRoute,
    private taskFilterService: TaskFilterService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.categoryName = params?.category;
      this.filteredEntities = params?.ids;
      this.filteredView = params?.filteredView === 'true';
    });

    if (this.categoryName === 'team') {
      this.groupedByTeam = true;
      this.groupedByTemplate = false;
      this.groupedByTag = false;
      this.groupedByPatient = false;
    }
    if (this.categoryName === 'template') {
      this.groupedByTeam = false;
      this.groupedByTemplate = true;
      this.groupedByTag = false;
      this.groupedByPatient = false;
    }
    if (this.categoryName === 'tag') {
      this.groupedByTeam = false;
      this.groupedByTemplate = false;
      this.groupedByTag = true;
      this.groupedByPatient = false;
    }
    if (this.categoryName === 'patient') {
      this.groupedByTeam = false;
      this.groupedByTemplate = false;
      this.groupedByTag = false;
      this.groupedByPatient = true;
    }
    this.taskFilterService.filteredEmitter.subscribe((didFilter) => {
      this.isFiltered = didFilter;
    });
    this.tempFilteredEntities = this.filteredEntities?.split(',').map(Number);

    this.taskService
      .getCategoriesForGroupTasks(this.categoryName, this.tempFilteredEntities)
      .subscribe((res) => {
        if (res) {
          this.categories = res.data;
          this.categories.forEach((ele) => {
            if (ele.tasks) {
              ele.tasks.forEach((user) => {
                this.userIds.push(user);
              });
            }
          });
          if (this.userIds.length > 0) {
            this.taskService.getUsersbyId(this.userIds).subscribe((reso) => {
              this.userObjects = [];
              this.userObjects = reso.pageOfItems;
              this.cdr.detectChanges();
            });
          }
        }
      });
  }
  backToMainListView() {
    this._location.back();
    this.taskFilterService.backFromGroupByView.next(true);
  }
  ngOnDestroy() {
    this.subscriptions.forEach((el) => el.unsubscribe());
  }
}
